import React from 'react'
import { Columns } from 'components/elements'
import './howitworks.sass'

const HowItWorks = () => {
  return (
    <Columns className="is-vcentered">
      <Columns.Column size={5}>
        <h2 className="has-text-weight-extra-bold is-size-3 how-it-works-heading">
          How it works
        </h2>
        <div className="hiw-point">
          <div className="hiw-num">
            <span>01</span>
          </div>
          <div className="hiw-content">
            <h3 className="has-text-weight-extra-bold">Find your motorcycle</h3>
            <p>
              Search from thousands of motorcycles all over the country. Looking
              for a particular brand or location? We’ve probably got it.
            </p>
          </div>
        </div>
        <div className="hiw-point">
          <div className="hiw-num">
            <span>02</span>
          </div>
          <div className="hiw-content">
            <h3 className="has-text-weight-extra-bold">Book your days</h3>
            <p>
              Pick your days. After a short approval process, you’ll meet the
              owner to get your keys and inspect your ride.
            </p>
          </div>
        </div>
        <div className="hiw-point">
          <div className="hiw-num">
            <span>03</span>
          </div>
          <div className="hiw-content">
            <h3 className="has-text-weight-extra-bold">Ride the world</h3>
            <p>
              Enjoy the ride of your life. Be safe. Be respectful. Have fun.
              Don’t forget to leave the owner a stellar review.
            </p>
          </div>
        </div>
        <div className="has-text-centered home-hiw-learn-more">
          Learn how to{' '}
          <a href="/list-your-motorcycle">list your own motorcycle</a> on
          Twisted Road for rent.
        </div>
      </Columns.Column>
      <Columns.Column size={5} offset={2} className="hide-mobile">
        <img
          src="https://res.cloudinary.com/twisted-road/image/upload/s--3_j0f88v--/c_scale,q_auto,w_500,f_auto/v1565145350/frontend_assets/homepage-images/little-biker-man-so-cute.jpg"
          alt="Infographic of a man hanging up a picture of a motorcycle"
          width="640px"
          height="360px"
        />
      </Columns.Column>
    </Columns>
  )
}

export default HowItWorks
